import { PEER } from '../constants'

/**
 * Configuration object for a Peer.
 * @typedef {Object} PeerConfig
 * @property {Object} [rtcConfig] Configuration for the native RTCPeerConnection.
 * @property {String} [trickleIceMode=FULL] The initial mode the Peer will use when receiving ICE candidates.
 * @property {Boolean} [removeBundling=false] Remove the a=group attribute to stop media bundling
 * @property {Function} [halfTrickleThreshold] Function that determines whether the threshold has been met when in HALF trickle mode.
 */
export default {
  rtcConfig: {
    sdpSemantics: PEER.SDP_SEMANTICS.UNIFIED_PLAN
  },
  trickleIceMode: PEER.TRICKLE_ICE.FULL,
  removeBundling: false,
  halfTrickleThreshold: isPassedHalfTrickleThreshold
}

/**
 * Default function for determining whether the HALF trickle ICE threshold has
 *    been met, to start trickling ICE candidates.
 * Defines the threshold as one relay candidate being gathered.
 * @method isPassedHalfTrickleThreshold
 * @param  {String}             sdp          The local SDP of the Peer.
 * @param  {RTCIceCandidate}    iceCandidate The native candidate object that triggered this check.
 * @param  {Number}             time         The amount of time (ms) since ICE collection began.
 * @return {Boolean} Whether the "half trickle" threshold has been passed.
 */
function isPassedHalfTrickleThreshold ({ sdp, iceCandidate, time }) {
  const passedHalf = iceCandidate.candidate.indexOf('relay') !== -1
  return passedHalf
}
